import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, MonitorPlay, GraduationCap, PhoneCall } from "lucide-react";
import {useNavigate} from "react-router-dom";

const CTASection = () => {
    const navigate = useNavigate();
    const actions = [
        {
            text: "Join our Free Webinar on Time Trading Techniques",
            icon: <MonitorPlay className="w-6 h-6" />,
            sub: "Introduction to forecasting",
            color: "text-blue-500",
            bg: "bg-blue-500/10",
            border: "hover:border-blue-500/50",
            link:""
        },
        {
            text: "Join our Time Technique Trading Mastery",
            icon: <GraduationCap className="w-6 h-6" />,
            sub: "Full institutional syllabus",
            color: "text-purple-500",
            bg: "bg-purple-500/10",
            border: "hover:border-purple-500/50",
            link:"/courses"
        },
        {
            text: "Book a Discovery Call",
            icon: <PhoneCall className="w-6 h-6" />,
            sub: "Speak with a strategist",
            color: "text-emerald-500",
            bg: "bg-emerald-500/10",
            border: "hover:border-emerald-500/50",
            link:"/contact"
        }
    ];

    return (
        <section className="relative w-full py-24 px-4 overflow-hidden  font-poppins">

            {/* Background Decor */}
            <div className="absolute inset-0 opacity-[0.03] dark:opacity-[0.05]"
                 style={{ backgroundImage: 'radial-gradient(#444 1px, transparent 1px)', backgroundSize: '32px 32px' }}>
            </div>

            <div className="max-w-5xl mx-auto relative z-10">

                {/* TEXT CONTENT */}
                <div className="text-center mb-16 space-y-6">

                    {/* --- NEW CHIP TITLE --- */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="inline-flex items-center gap-2 px-3 py-1 mb-6 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-sm"
                    >
                        <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse"></span>
                        <span className="text-xs font-bold tracking-widest text-primary uppercase">
                                                    The Institutional Edge
                        </span>
                    </motion.div>
                    {/* ---------------------- */}

                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1, duration: 0.5 }}
                        className="text-3xl md:text-5xl font-bold text-dark dark:text-light leading-tight"
                    >
                        Ready to trade the market <br className="hidden md:block"/>
                        the way <span className="text-primary relative inline-block">
              institutions
              <svg className="absolute w-full h-2 bottom-0 left-0 text-primary opacity-20" viewBox="0 0 100 10" preserveAspectRatio="none">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" />
              </svg>
            </span> do?
                    </motion.h2>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                        className="text-lg md:text-2xl font-medium"
                    >
                        <p className="text-gray-400 line-through decoration-gray-400/50 decoration-2">
                            Stop chasing indicators.
                        </p>
                        <p className="text-dark dark:text-light mt-2 font-bold text-2xl md:text-3xl">
                            Start <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-purple-600">forecasting time.</span>
                        </p>
                    </motion.div>
                </div>

                {/* ACTION CARDS */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {actions.map((item, index) => (
                        <motion.button
                            onClick={() => navigate(item.link)}
                            key={index}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3 + (index * 0.1), duration: 0.5 }}
                            whileHover={{ y: -5 }}
                            className={`group flex flex-col items-center justify-between p-8 rounded-2xl bg-white dark:bg-bg-dark-2 shadow-lg shadow-gray-200/50 dark:shadow-none border border-gray-100 dark:border-gray-800 transition-all duration-300 ${item.border}`}
                        >
                            <div className="flex flex-col items-center text-center space-y-4">
                                <div className={`w-16 h-16 rounded-full flex items-center justify-center ${item.bg} ${item.color} mb-2 group-hover:scale-110 transition-transform duration-300`}>
                                    {item.icon}
                                </div>
                                <div>
                                    <h3 className="text-lg font-bold text-dark dark:text-light mb-1 leading-snug">
                                        {item.text.replace("Join our ", "").replace("Book a ", "")}
                                    </h3>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">
                                        {item.sub}
                                    </p>
                                </div>
                            </div>
                            <div className="mt-8 flex items-center gap-2 text-sm font-semibold text-dark/70 dark:text-light/70 group-hover:text-primary transition-colors">
                                <span>Get Started</span>
                                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                            </div>
                        </motion.button>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default CTASection;